module.exports = __webpack_public_path__ + "media/images/work_articles_tab2_icon-on-ebff8fad231f7beafd36f1ef39ee82eb.png";